export const CONTEXT_MESH_HUB_ROUTE = "/context-meshes";
export const NEW_CONTEXT_MESH_ROUTE = `${CONTEXT_MESH_HUB_ROUTE}/new`;
export const CONTEXT_MESH_DRAFTS_ROUTE = `${CONTEXT_MESH_HUB_ROUTE}/drafts`;

export interface ContextMeshHubDeepLink {
    contextMeshId: string | null;
    draftId: number | null;
    action: "hub" | "create" | "draft" | "console" | "refresh";
    section: "console" | "files" | "integrations";
}

const CONTEXT_MESH_ID_PATTERN = /^\/context-meshes\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:\/(files|integrations|refresh))?$/i;
const CONTEXT_MESH_DRAFT_PATTERN = /^\/context-meshes\/drafts\/([1-9]\d*)$/;

export function parseContextMeshHubDeepLink(pathname: string): ContextMeshHubDeepLink | null {
    const normalizedPath = pathname.replace(/\/+$/, "") || "/";
    if (normalizedPath === CONTEXT_MESH_HUB_ROUTE) {
        return { contextMeshId: null, draftId: null, action: "hub", section: "console" };
    }
    if (normalizedPath === NEW_CONTEXT_MESH_ROUTE) {
        return { contextMeshId: null, draftId: null, action: "create", section: "console" };
    }

    const draftMatch = normalizedPath.match(CONTEXT_MESH_DRAFT_PATTERN);
    if (draftMatch) {
        return {
            contextMeshId: null,
            draftId: Number(draftMatch[1]),
            action: "draft",
            section: "console"
        };
    }

    const match = normalizedPath.match(CONTEXT_MESH_ID_PATTERN);
    return match ? {
        contextMeshId: match[1].toLowerCase(),
        draftId: null,
        action: match[2] === "refresh" ? "refresh" : "console",
        section: match[2] === "files" || match[2] === "integrations" ? match[2] : "console"
    } : null;
}

export function contextMeshRefreshUrl(contextMeshId: string): string {
    return `${contextMeshHubUrl(contextMeshId)}/refresh`;
}

export function contextMeshDraftUrl(draftId: number): string {
    if (!Number.isSafeInteger(draftId) || draftId <= 0) {
        throw new Error("A positive Context Mesh draft id is required");
    }
    return `${CONTEXT_MESH_DRAFTS_ROUTE}/${draftId}`;
}

export function contextMeshHubUrl(
    contextMeshId?: string | null,
    section: ContextMeshHubDeepLink["section"] = "console"
): string {
    if (!contextMeshId) return CONTEXT_MESH_HUB_ROUTE;
    const parsed = parseContextMeshHubDeepLink(`${CONTEXT_MESH_HUB_ROUTE}/${contextMeshId}`);
    if (!parsed?.contextMeshId) throw new Error("A valid Context Mesh UUID is required");
    return `${CONTEXT_MESH_HUB_ROUTE}/${parsed.contextMeshId}${section === "console" ? "" : `/${section}`}`;
}
